/* aw-fc.js — de pijlen van de sectie "Featured collection".
 *
 * Horizons carrousel is een eigen element met schaduw-DOM; die hebben we hier
 * niet nodig. Een schuifvak met scroll-snap doet hetzelfde en de pijlen zijn
 * twee knoppen die een kaartbreedte opschuiven.
 *
 * Vorige keer geleerd: meet de sprong aan een ECHTE kaart in plaats van hem
 * uit een instelling te rekenen. De breedte hangt aan een containervraag en
 * kan per breedte anders uitpakken. */
(() => {
  const SOEPEL = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

  function sprong(spoor) {
    const kaart = spoor.querySelector('.aw-fc__kaart');
    if (!kaart) return spoor.clientWidth;
    const twee = spoor.querySelectorAll('.aw-fc__kaart');
    if (twee.length > 1) {
      return twee[1].getBoundingClientRect().left - twee[0].getBoundingClientRect().left;
    }
    return kaart.getBoundingClientRect().width;
  }

  function knoppenBijwerken(baan) {
    const spoor = baan.querySelector('[data-aw-fc-spoor]');
    const terug = baan.querySelector('[data-aw-fc-terug]');
    const verder = baan.querySelector('[data-aw-fc-verder]');
    if (!spoor) return;
    const rest = spoor.scrollWidth - spoor.clientWidth - spoor.scrollLeft;
    if (terug) terug.hidden = spoor.scrollLeft <= 1;
    if (verder) verder.hidden = rest <= 1;
  }

  function koppel(baan) {
    const spoor = baan.querySelector('[data-aw-fc-spoor]');
    if (!spoor || spoor.dataset.awGekoppeld) return;
    spoor.dataset.awGekoppeld = '1';

    baan.querySelector('[data-aw-fc-terug]')?.addEventListener('click', () => {
      spoor.scrollBy({ left: -sprong(spoor), behavior: SOEPEL });
    });
    baan.querySelector('[data-aw-fc-verder]')?.addEventListener('click', () => {
      spoor.scrollBy({ left: sprong(spoor), behavior: SOEPEL });
    });
    spoor.addEventListener('scroll', () => knoppenBijwerken(baan), { passive: true });
    new ResizeObserver(() => knoppenBijwerken(baan)).observe(spoor);
    knoppenBijwerken(baan);
  }

  const start = () => document.querySelectorAll('.aw-fc__baan').forEach(koppel);
  start();
  document.addEventListener('shopify:section:load', start);
})();
